/* Make It Lab - Same-Day Method line item property fix.
   The Same-Day widget (#milsd) has radios named properties[Same-Day Method] with the first one checked by default.
   Hidden radios still submit, so the cart got "Same-Day Method: Pickup today 3:00-5:00 PM" after the cutoff or when
   the customer unchecks "Yes, I need it today". Here the property is only sent while the free same-day box is open
   AND the opt-in is checked; in every other case the field has no name, so it never reaches the cart. */
(function(){
  var NAME='properties[Same-Day Method]';
  function init(){
    var box=document.getElementById('milsd'); if(!box||box.getAttribute('data-sdfix')) return true;
    var radios=box.querySelectorAll('input[type=radio]'); if(!radios.length) return false;
    box.setAttribute('data-sdfix','1');
    Array.prototype.forEach.call(radios,function(r){ if(r.name===NAME) r.name='mil_sd_ui'; r.setAttribute('form','mil-sd-ui-only'); });
    var pr=document.createElement('input'); pr.type='hidden'; pr.id='milprop'; pr.setAttribute('data-name',NAME);
    var holder=document.getElementById('milm')||box; holder.parentNode.insertBefore(pr,holder);
    var cb=document.getElementById('milcb'), fr=document.getElementById('milfree');
    function sync(){
      var r=box.querySelector('input[type=radio]:checked');
      var open=fr&&fr.style.display!=='none'&&(!cb||cb.checked);
      if(r) pr.value=r.value;
      if(open&&r){ pr.setAttribute('name',NAME); pr.disabled=false; } else { pr.removeAttribute('name'); pr.disabled=true; }
    }
    sync();
    box.addEventListener('change',sync,true);
    document.addEventListener('click',sync,true);
    document.addEventListener('submit',sync,true);
    setInterval(sync,300);
    return true;
  }
  function boot(){ if(init()) return; var n=0,t=setInterval(function(){ if(init()||++n>40) clearInterval(t); },500); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();

/* Same-Day page: the Same-Day block used to be relocated ABOVE the size selector, which pushed the "Build your own Gang Sheet" CTA down to ~1330px.
   Put it full-width right under the product area (same as the DTF builder page), so the CTA comes first. Runs after the template's own relocation. */
(function(){
  function moveSD(){
    var sd=document.getElementById('milsd'); if(!sd) return true;
    var block=sd.closest('.product-block-list__item')||sd;
    if(block.getAttribute('data-mil-relocated')) return true;
    var pbl=document.querySelector('.product-block-list');
    var rr=pbl?pbl.closest('product-rerender'):null, cont=rr?rr.parentElement:null;
    if(!rr||!cont) return false;
    block.setAttribute('data-mil-moved','1'); block.setAttribute('data-mil-relocated','1');
    block.style.width='100%'; block.style.marginTop='28px';
    cont.insertBefore(block,rr.nextSibling);
    /* the template keeps inserting its content blocks right after the product area; keep the Same-Day block first */
    var fixing=false;
    new MutationObserver(function(){
      if(fixing||rr.nextElementSibling===block) return;
      fixing=true; cont.insertBefore(block,rr.nextSibling); setTimeout(function(){fixing=false},0);
    }).observe(cont,{childList:true});
    return true;
  }
  function go(){ setTimeout(function(){ if(moveSD()) return; var n=0,t=setInterval(function(){ if(moveSD()||++n>20) clearInterval(t); },400); },0); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
})();
